import React from 'react';
import moment from 'moment';

import {
  defaultDateFilters,
  fetchFilterData,
  isDesktopDevice,
  isFilterExpired,
  localstorageAvailable,
  updateDateRange
} from '../../../../services/services';

import Adults from '../../../../common/components/adults';
import Children from '../../../../common/components/children';
import DatePicker from '../../../../common/components/datepicker';
import Destination from '../../../../common/components/destination';
import FlightAirport from '../../../../common/components/flight-airport';
import FlightType from '../../../../common/components/flight-type';
import HotelName from '../../../../common/components/hotel_name';
import { T } from '../../../../../../common/locale/translate';
import Tab from '../../../../common/components/tab';
import Tabs from '../../../../common/components/tabs';
import TripLength from '../../../../common/components/trip-length';
import { historyService } from '../../../../services/history';
import Accommodations from '../../../../common/components/accommodations';
import PersonPrice from '../../../../common/components/person_price';
import HotelStandard from '../../../../common/components/hotel_standard';
import Facilities from '../../../../common/components/facilities';
import Alimentation from '../../../../common/components/alimentation';
import GridItem from '../../../../common/components/grid-item';
import Operators from '../../../../common/components/operators';
import Transfer from '../../../../common/components/transfer';

export default class SearchForm extends React.Component {
  constructor() {
    super();
    this.state = {
      url: '',
      default_offer_type: 'A',
      duration: { default: {}, values: [] },
      filterDataCacheTime: 259200000,
      active: false,
      alimentations: [],
      startDate: defaultDateFilters().from,
      endDate: defaultDateFilters().to,
      activeIndex: 0,
      currentOfferType: '',
      params: null,
      default_activity: {
        departure_airports: true,
        duration: true,
        flight_type: true,
        hotel_name: true
      },
      activity: {
        departure_airports: true,
        duration: true,
        flight_type: true,
        hotel_name: true
      },
      flightTypes: ['C', 'C1', 'C2'],
      icons: {
        A: '/img/icons/search/tours.svg',
        S: '/img/icons/search/hotels.svg',
        C: '/img/icons/search/plane_tickets.svg',
        C1: '/img/icons/search/plane_tickets.svg',
        C2: '/img/icons/search/plane_tickets.svg',
        GROUP: '/img/icons/search/group_reservations.svg',
        search: '/img/icons/search/search.svg'
      },
      isMoreOptions: false,
      rating: 0
    };
    this.state.durationMin = this.state.params
      ? this.state.params.duration_min
      : 7;
    this.state.returnDateRangeStart = moment
      .unix(this.state.startDate)
      .add(this.state.durationMin, 'days');
  }

  componentDidMount() {
    this.setInitialData();
  }

  render() {
    const { icons } = this.state;
    return (
      <section className="search-form wrapper">
        <div className="search-form-outside-wrapper active">
          <div className="search-form-inside-wrapper">
            <div className="tabs">
              <Tabs
                activeIndex={this.state.activeIndex}
                ref="offer_type"
                handleTabChange={this.handleTabChange}
                offerType={this.state.default_offer_type}
                class_name="mobile-tabs"
              >
                <Tab
                  name={T('holiday')}
                  type="tours"
                  value="A"
                  icon={icons['A']}
                />
                <Tab
                  name={T('only_hotels')}
                  type="hotels"
                  value="S"
                  icon={icons['S']}
                />
                <Tab
                  name={T('flight_tickets')}
                  type="plane-tickets"
                  value="C"
                  icon={icons['C']}
                />
                <Tab
                  name={T('group_reservations')}
                  mobile_name={T('group_reservations_short')}
                  type="group-reservations"
                  value="GROUP"
                  icon={icons['GROUP']}
                />
              </Tabs>
            </div>
            <div className="search">
              <div
                className={`search-wrapper ${
                  this.state.isMoreOptions ? 'show' : ''
                }`}
              >
                <div className="row-wrapper">
                  <FlightType
                    ref="flight_type"
                    visible={
                      this.state.flightTypes.indexOf(
                        this.state.default_offer_type
                      ) > -1
                    }
                    offer_type={
                      this.state.default_offer_type == 'C'
                        ? 'C2'
                        : this.state.default_offer_type
                    }
                    changeActivityStates={this.handleFlightTypeChange}
                  />
                </div>
                <div className="row-wrapper">
                  <FlightAirport
                    onClick={() => {}}
                    title={T('departure_from')}
                    ref="departure_airports"
                    filter_active={this.state.activity.departure_airports}
                    marginOffset={92}
                  />
                  <Destination
                    title={T('trip_direction')}
                    ref="regions"
                    marginOffset={92}
                  />
                  <HotelName
                    title={T('hotel_name_filter')}
                    ref="hotel_name"
                    filter_active={this.state.activity.hotel_name}
                    marginOffset={92}
                  />
                </div>
                <div className="row-wrapper">
                  <DatePicker
                    title={T('departure_from_day')}
                    ref="departure_date"
                    className="date-from"
                    onChange={this.updateDates.bind(this, 'startDate')}
                    date={this.state.startDate}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    selectsStart
                    withPortal={!isDesktopDevice()}
                    name="departure_date"
                  />
                  <DatePicker
                    title={T('arrival_to_day')}
                    ref="return_date"
                    className="date-to"
                    onChange={this.updateDates.bind(this, 'endDate')}
                    date={this.state.endDate}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    selectsEnd
                    withPortal={!isDesktopDevice()}
                    name="return_date"
                    minDate={this.state.returnDateRangeStart}
                  />
                  <TripLength
                    title={T('admin_special_offers_duration')}
                    ref="duration"
                    duration={this.state.duration}
                    filter_active={this.state.activity.duration}
                    marginOffset={92}
                    on_change_duration={this.updateDuration.bind(this)}
                  />
                  <Adults
                    title={T('adults_number')}
                    ref="adults_number"
                    marginOffset={92}
                  />
                  <Children
                    title={T('children_number')}
                    ref="children_ages"
                    marginOffset={92}
                  />
                </div>
                <div
                  className={`more-options ${
                    this.state.isMoreOptions
                      ? 'more-options-show'
                      : 'more-options-hide'
                  }`}
                >
                  <GridItem className="transfers" gridArea="transfers">
                    <h5 className="option-title">{T('transfer_title')}</h5>
                    <Transfer ref="transfer" />
                  </GridItem>
                  <GridItem className="boards" gridArea="boards">
                    <h5 className="option-title">{T('board')}</h5>
                    <Alimentation
                      title={T('board')}
                      ref="boards"
                      alimentations={this.state.alimentations}
                    />
                  </GridItem>
                  <GridItem
                    gridArea="price"
                    className={
                      this.state.isMoreOptions ? 'price-show' : 'price-hide'
                    }
                  >
                    <PersonPrice
                      title={T('maximal_price_eur')}
                      ref="price_max_eur"
                      price_max_eur=""
                    />
                  </GridItem>
                  <GridItem gridArea="accommodations">
                    <Accommodations
                      withMobileTitle
                      title={T('accommodation')}
                      ref="accommodations"
                    />
                  </GridItem>
                  <GridItem gridArea="rating">
                    <HotelStandard
                      withMobileTitle
                      title={T('hotel_standard_from')}
                      ref="rating_min"
                    />
                  </GridItem>

                  <GridItem gridArea="facilities">
                    <Facilities title={T('facilities')} ref="facilities" />
                  </GridItem>
                  <GridItem gridArea="operators">
                    <Operators
                      title={T('operator_name')}
                      ref="operators"
                      offer_type={this.state.default_offer_type}
                    />
                  </GridItem>
                </div>
              </div>
              <div className="action-wrapper">
                <button onClick={this.handleSearch} className="search-button">
                  <img
                    src={icons['search']}
                    className="search-icon"
                    alt=""
                    width="18px"
                    height="18px"
                  />
                  <span>{T('look_for')}</span>
                </button>
                <button
                  className={`options-button ${
                    this.state.isMoreOptions ? 'show' : 'hide'
                  }`}
                  onClick={this.handleToggleMoreOptions}
                >
                  <span>{T('more_options')}</span>
                  <i className="dropdown-icon fa fa-chevron-down" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  setInitialData = () => {
    if (localstorageAvailable()) {
      if (isFilterExpired('default', this.state.filterDataCacheTime)) {
        this.updateFilterSource();
      } else {
        const filter_data = JSON.parse(localStorage.getItem('default_filter'));
        this.setState({
          duration: filter_data.duration,
          alimentations: filter_data.alimentations_list
        });
      }
    } else {
      this.updateFilterSource();
    }
  };

  updateFilterSource = () => {
    fetchFilterData('default_filter').then(
      response => {
        const filter_data = response.data;
        if (localstorageAvailable()) {
          localStorage.setItem('default_filter', JSON.stringify(filter_data));
          localStorage.setItem(
            'default_filter_last_update',
            new Date().getTime()
          );
        }
        this.setState({
          duration: filter_data.duration,
          alimentations: filter_data.alimentations_list
        });
      },
      error => {
        console.log('Error when fetching default filter', error);
      }
    );
  };

  changeActivityStates = offer_type => {
    const activities = {
      A: {
        ...this.state.default_activity
      },
      S: {
        ...this.state.default_activity,
        departure_airports: false
      },
      C1: {
        ...this.state.default_activity,
        duration: false,
        hotel_name: false
      },
      C2: {
        ...this.state.default_activity,
        hotel_name: false
      },
      C: {
        ...this.state.default_activity,
        hotel_name: false
      }
    };

    this.setState({ activity: activities[offer_type] });
  };
  handleToggleMoreOptions = () => {
    this.setState({
      isMoreOptions: !this.state.isMoreOptions
    });
  };
  handleChaneRating = rating => {
    this.setState({
      rating
    });
  };

  handleTabChange = (type, index) => {
    if (type == 'GROUP') {
      this.setState({ default_offer_type: type, activeIndex: index }, () =>
        this.handleSearch()
      );
    } else {
      this.setState({ default_offer_type: type, activeIndex: index });
      this.changeActivityStates(type);
    }
  };

  handleFlightTypeChange = offer_type => {
    this.setState({ default_offer_type: offer_type });
    this.changeActivityStates(offer_type);
  };

  updateDates = (name, date) => {
    this.setState(
      updateDateRange(name, date, {
        startDate: this.state.startDate,
        endDate: this.state.endDate
      }),
      () =>
        this.setState({
          returnDateRangeStart: moment
            .unix(this.state.startDate)
            .add(this.state.durationMin, 'days')
        })
    );
  };

  updateDuration = duration => {
    this.setState({
      durationMin: duration.min,
      returnDateRangeStart: moment
        .unix(this.state.startDate)
        .add(duration.min, 'days')
    });
  };

  handleSearch = () => {
    let temp = {},
      key,
      value;
    Object.keys(this.refs).map(v => {
      key = v;
      value = this.refs[v].returnSearchedValue();

      if (value) {
        switch (key) {
          case 'duration': {
            temp['duration_min'] = value.min;
            temp['duration_max'] = value.max;
            break;
          }
          case 'offer_type': {
            if (value !== 'C') {
              temp['offer_type'] = value;
            } else {
              temp['offer_type'] = 'C2';
            }
            break;
          }
          case 'flight_type': {
            temp['offer_type'] = value;
            break;
          }
          default: {
            temp[key] = value;
          }
        }
      }

      temp['offer_type'] = temp['offer_type'] ? temp['offer_type'] : 'A';
    });
    // TODO add prefix to controller and change switch to sth better
    window.location = `/offers?${historyService.parseObject2Params(temp)}`;
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/home/components/search/search_form.js